import { Box } from "@chakra-ui/react";
import React from "react";
import * as Draft from "src/scenes/orgAdmin/formTemplates/types/draft";
import * as AF from "src/types/formTemplate";
import * as GQL from "src/types/graphql";
import * as RD from "src/types/remoteData";
import { QuestionFormEdit } from "./Edit";
import { SchoolItem } from "./types";
import { QuestionFormView } from "./View";

type Mode = "View" | "Edit";
type Props = {
  sectionType: AF.SectionType;
  question: Draft.Question;
  schools: RD.RemoteData<unknown, SchoolItem[]>;
  onUpdate?: (question: Draft.Question) => Promise<void>;
  onRemove?: (question: Draft.Question) => Promise<void>;
  hasChanges: boolean;
  gradesConfig: GQL.GetGradesConfigByOrganization_grade_config[];
  otherQuestions: readonly Draft.Question[];
};
export const QuestionForm: React.FC<Props> = ({
  sectionType,
  question,
  onUpdate,
  onRemove,
  schools,
  hasChanges,
  gradesConfig,
  otherQuestions,
}) => {
  const [mode, setMode] = React.useState<Mode>("View");

  const onEditButtonClick = React.useCallback(() => {
    setMode("Edit");
  }, []);
  const onCancelButtonClick = React.useCallback(() => {
    setMode("View");
  }, []);

  const onUpdateButtonClick = React.useCallback(
    async (updatedQuestion: Draft.Question) => {
      if (onUpdate) {
        await onUpdate(updatedQuestion);
      }
      setMode("View");
    },
    [onUpdate]
  );

  const onRemoveButtonClick = React.useCallback(() => {
    if (onRemove) {
      onRemove(question);
    }
  }, [onRemove, question]);

  let content;
  switch (mode) {
    case "Edit": {
      content = (
        <QuestionFormEdit
          sectionType={sectionType}
          question={question}
          onCancelButtonClick={onCancelButtonClick}
          onUpdate={onUpdateButtonClick}
          schools={schools}
          gradesConfig={gradesConfig}
          otherQuestions={otherQuestions}
        />
      );
      break;
    }

    case "View": {
      content = (
        <QuestionFormView
          question={question}
          hasChanges={hasChanges}
          onEditButtonClick={onEditButtonClick}
          onRemoveButtonClick={onRemoveButtonClick}
          schools={schools}
        />
      );
      break;
    }

    default:
      const _exhaustiveCheck: never = mode;
      return _exhaustiveCheck;
  }

  return <Box id={question.id}>{content}</Box>;
};

export { QuestionFormEdit } from "./Edit";
export { QuestionFormView } from "./View";
